<!--设备对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="device" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-属性' : '新建' + '-属性'" :has-form="true" class="time-event-dialog-modal" @close="close"
      @confirm="handleConfirm">
      <gs-form label-width="56px" label-position="left" gap="small">
        <gs-form-item label="名称" prop="target" class="form-item-radio">
          <gs-input ref="nameInput" v-model="name" />
        </gs-form-item>
        <!--  <gs-form-item
          label="位置"
          prop="target"
          class="form-item-radio"
        >
          <gs-input v-model="form.address" />
        </gs-form-item> -->
        <gs-form-item label="描述" prop="target" class="form-item-radio">
          <gs-input ref="nameInput" v-model="description" />
        </gs-form-item>

        <gs-form-item label="链接" prop="fileLink" class="form-item-radio">
          <gs-input v-model="fileLink" type="text" />
        </gs-form-item>

        <div class="desc">
          <fieldset>
            <legend />
            <div class="fifty-width-box">
              <el-row>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">设备型号：{{ form.dev_type }}</span>
                </el-col>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">部署时间：{{ operationTime }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">IP：{{ form.ip }}</span>
                </el-col>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">DNS：{{ form.dns }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">子网掩码：{{ form.mask }}</span>
                </el-col>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">默认网关：{{ form.gateway }}</span>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">固件版本：{{ form.version }}</span>
                </el-col>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">boot版本：{{ form.boot_version }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">MQTT topic：{{ form.topic }}</span>
                </el-col>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">SN：{{ form.sn }}</span>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">连接状态：{{ form.isLinked }}</span>
                </el-col>
                <el-col :span="12">
                  <span style="color: #a3a1a1; font-size: 10px">mac：{{ form.mac }}</span>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="15">
                  <span style="color: #a3a1a1; font-size: 10px">Din：{{ form.din }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="5" :offset="14">
                  <span style="
                      color: #ff7b00;
                      font-size: 10px;
                      cursor: pointer;
                      margin-left: 15px;
                    " @click="trendData">通讯记录</span>
                </el-col>
                <el-col :span="5">
                  <span style="
                      color: #ff7b00;
                      font-size: 10px;
                      cursor: pointer;
                      margin-left: 15px;
                    " @click="scene">场景信息</span>
                </el-col>
              </el-row>
            </div>
            <div class="fifty-width-box">
              <el-row>
                <el-col :span="24">
                  <span style="color: #fdd702; font-size: 10px">以下操作会影响设备的正常运行,请谨慎操作！！！</span>
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px">
                <!--  <el-col :span='6'>
                  <el-button size="mini">复位ICU</el-button>
                </el-col> -->
                <el-col :span="6">
                  <gs-button @click="updateTempOpen">升级固件</gs-button>
                </el-col>
                <el-col :span="6">
                  <gs-button @click="updateTempBootOpen">升级boot</gs-button>
                </el-col>
                <el-col :span="6">
                  <gs-tooltip class="item" effect="dark" content="Top Center 提示文字" placement="top"
                    title="更新程序时设备将暂时断开连接，请谨慎操作">
                    <gs-button size="mini" @click="tableDataIcu">更新程序</gs-button>
                  </gs-tooltip>
                </el-col>
                <el-col :span="6">
                  <gs-button @click="updateWeb">&nbsp;重启ICU&nbsp;</gs-button>
                </el-col>
              </el-row>
            </div>
            <div class="fifty-width-box">
              <el-row style="margin-top: 10px">
                <el-col :span="6">
                  <gs-button @click="updateNewWeb">更新web</gs-button>
                </el-col>
                <el-col :span="6">
                  <gs-tooltip class="item" effect="dark" content="Top Center 提示文字" placement="top"
                    title="程序正在升级中，再次点击断开连接">
                    <gs-button @click="updateTit">{{ top }}</gs-button>
                  </gs-tooltip>
                </el-col>
                <!--  <el-col :span='6'>
                  <el-button
                    size="mini"
                  >停止协助</el-button>
                </el-col>      -->
              </el-row>
            </div>
          </fieldset>
        </div>
      </gs-form>
      <span slot="footer" class="dialog-footer">
        <div class="btn-device">
          <el-row :gutter="15">
            <!--  <el-col
              :span=7
            > 
              <el-button
                size='mini'
                @click="updateWeb"
              >更新web</el-button>
            </el-col> -->

            <el-col :span="5" :offset="9">
              <el-button type="primary" size="mini" @click="handleConfirm">确 定</el-button>
            </el-col>
            <el-col :span="5">
              <el-button size="mini" @click="beforeClose">取 消</el-button>
            </el-col>
            <el-col :span="5">
              <el-button size="mini">帮 助</el-button>
            </el-col>
          </el-row>
        </div>
      </span>
    </gs-modal>
    <gs-modal v-loading="loading" v-model="subDevice" :before-close="beforeClose1" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-子设备' : '新建' + '-子设备'" :has-form="true" class="my-test-class" @close="close"
      @confirm="handleConfirm1">
      <gs-form label-width="56px" label-position="left" gap="small">
        <!-- <gs-form-item
          label="名称"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            ref="nameInput"
            v-model="name"
            disabled
          />
        </gs-form-item> -->
        <gs-form-item label="描述" prop="target" class="form-item-radio">
          <gs-input v-model="description" />
        </gs-form-item>
        <gs-form-item label="位置" prop="address" class="form-item-radio">
          <gs-input v-model="form.address" />
        </gs-form-item>
        <gs-form-item label="型号" prop="address" class="form-item-radio">
          <gs-input v-model="form.number" />
        </gs-form-item>
        <gs-form-item label="链接" prop="fileLink" class="form-item-radio">
          <gs-input v-model="form.fileLink" />
        </gs-form-item>
        <gs-form-item label="说明" prop="address" class="form-item-radio">
          <el-input v-model="form.model" type="textarea"></el-input>
        </gs-form-item>
        <!-- <gs-form-item
          label="设备信息"
          class="form-item-radio"
        >
          <gs-input v-model="deviceMassage" />
        </gs-form-item>-->
        <!-- <gs-form-item
          label="Din"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            v-model="form.din"
            disabled
          />
        </gs-form-item>
        <gs-form-item
          label="地址"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            v-model="form.din"
            disabled
          />
        </gs-form-item>-->
        <!-- <div style="padding:10px 0;">
          <gs-button
            @click="checkDevice"
          >设备检测</gs-button>
          <gs-button
            @click="getDeviceMsg"
          >获取设备配置信息</gs-button>
        </div> -->
      </gs-form>
      <span slot="footer" class="dialog-footer">
        <el-row :gutter="15">
          <el-col :span="6" :offset="8">
            <gs-button @click="communicationShowOk" type="primary" size="mini">通讯记录</gs-button>
          </el-col>
          <!--  <el-col
            :span=6
          >
          
            <gs-button
              size='mini'
              @click="equipment"
            >设备信息</gs-button>
          </el-col> -->
          <el-col :span="5">
            <gs-button size="mini" type="primary" @click="handleConfirm1">确 定</gs-button>
          </el-col>
          <el-col :span="5">
            <gs-button size="mini" type="primary" @click="beforeClose1">取 消</gs-button>
          </el-col>
        </el-row>
      </span>
    </gs-modal>
    <gs-modal v-loading="loading" v-model="environment" :before-close="beforeCloseEviro"
      :before-confirm="beforeConfirmEviro" :title="tit" :has-form="true" class="time-event-dialog-modal"
      @close="environment = false" @confirm="handleConfirmEviro">
      <el-form ref="form" :model="sizeForm" label-width="70px" size="mini">
        <el-form-item label="名称">
          <gs-input v-model="form.name"></gs-input>
        </el-form-item>
        <el-form-item label="型号">
          <gs-input v-model="form.number"></gs-input>
        </el-form-item>
        <el-form-item label="面积">
          <gs-input v-model="form.addressOut"></gs-input>
        </el-form-item>
        <el-form-item label="位置">
          <gs-input v-model="form.personCharge"></gs-input>
        </el-form-item>
        <el-form-item label="场景类型">
          <el-radio-group v-model="form.resource">
            <el-radio label="空间"></el-radio>
            <el-radio label="设备"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </gs-modal>
    <gs-modal class="gsmodal-box" v-loading="loading" v-model="devicePopup" :before-close="beforeCloseDevice"
      :before-confirm="beforeCloseDevice" @close="devicePopup = false" @confirm="devicePopup = false"
      :title="name + '-通讯记录'" top="150px">
      <el-table :data="deviceArrayData" size="mini" height="520" :header-cell-style="{
        background: '#343434',
        color: '#c7c7c9',
        border: '1px solid #343434',
      }" class="personality-form" style="width: 100%">
        <el-table-column prop="timestamp" align="center" :formatter="timeTran" label="时间">
        </el-table-column>
        <el-table-column prop="description" align="center" label="状态">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer"></span>
    </gs-modal>
    <gs-modal v-model="updateTemp" :before-close="beforeCloseUpdateTemp" class="my-test-class" title="升级固件列表 "
      width="50%" @confirm="handleConfirmUpdateTemp">
      <!--  <input
        type="file" 267000 + 55000 = 322000 + 100000 
        id="uploadPic"
      /> -->
      <el-table :data="appArray" size="mini" height="320" :header-cell-style="{
        background: '#343434',
        color: '#c7c7c9',
        border: '1px solid #343434',
      }" class="personality-form" style="width: 100%">
        <el-table-column prop="name" align="center" label="名称" width="120">
        </el-table-column>
        <el-table-column prop="description" align="center" label="描述">
        </el-table-column>
        <el-table-column prop="version" align="center" label="版本" width="100">
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <!-- <gs-button size="mini" @click="appOk(scope.row)">下载</gs-button> -->
            <span style="color: #cd9069; cursor: pointer; margin-right: 5px" @click="appOk(scope.row)">下载</span>
            <!--   <span style="color:#CD9069;cursor:pointer;margin-right:5px">详情</span> -->
          </template>
        </el-table-column>
      </el-table>
      <div style="width: 100%" v-if="percentShow">
        <el-progress :percentage="percentage"></el-progress>
      </div>
    </gs-modal>
    <gs-modal v-model="updateTempBoot" :before-close="beforeCloseUpdateTempBoot" class="my-test-class" title="升级boot列表"
      @confirm="handleConfirmUpdateTempBoot">
      <!-- <input
        type="file"
        id="uploadPicBoot"
      /> -->
      <el-table :data="bootArray" size="mini" height="320" :header-cell-style="{
        background: '#343434',
        color: '#c7c7c9',
        border: '1px solid #343434',
      }" class="personality-form" style="width: 100%">
        <el-table-column prop="name" align="center" label="名称">
        </el-table-column>
        <el-table-column prop="version" align="center" label="版本">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <!--   <gs-button size="mini" @click="bootOk(scope.row)">下载</gs-button> -->
            <span @click="bootOk(scope.row)">下载</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="width: 100%" v-if="percentShow">
        <el-progress :percentage="percentage"></el-progress>
      </div>
    </gs-modal>

    <gs-modal v-model="scenarioConfigurationShow" :before-close="beforeCloseUpdateScenario" class="my-test-class"
      title="场景配置列表" @confirm="handleConfirmScenario">
      <el-table :data="scenarioArrayData" size="mini" height="320" :header-cell-style="{
        background: '#343434',
        color: '#c7c7c9',
        border: '1px solid #343434',
      }" class="personality-form" style="width: 100%">
        <el-table-column prop="name" align="center" label="名称">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <!--  <gs-button size="mini" @click="updateScenario(scope.row)">更新</gs-button> -->
            <span style="color: #cd9069; cursor: pointer; margin-right: 5px"
              @click="updateScenario(scope.row)">更新</span>
            <span style="color: #cd9069; cursor: pointer; margin-right: 5px" @click="descChangjing = true">详情</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="width: 100%" v-if="percentShow">
        <el-progress :percentage="percentage"></el-progress>
      </div>
    </gs-modal>
    <!-- 子设备通讯记录 -->
    <gs-modal v-model="showCommunication" :before-close="CommunicationClose" class="gsmodal-box" top="150px"
      :title="name + '-通讯记录'" @confirm="communicationShowOk">
      <el-table :data="communicationArray" size="mini" height="520" :header-cell-style="{
        background: '#343434',
        color: '#c7c7c9',
        border: '1px solid #343434',
      }" class="personality-form" style="width: 100%">
        <el-table-column prop="timestamp" align="center" :formatter="timeTran" label="时间">
        </el-table-column>
        <el-table-column prop="description" align="center" label="状态">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer"></span>
    </gs-modal>
    <gs-modal v-model="tUpdateWebShow" :before-close="UpdateWebShowClose" class="my-test-class" title="提示" top="300px"
      @confirm="UpdateWebShowOk">
      <span style="color: rgb(245, 229, 7)">更新web会影响设备的正常运行，是否继续更新？</span>
    </gs-modal>
    <gs-modal v-model="tUpdateIcuShow" :before-close="UpdateIcuShowClose" class="my-test-class" title="提示" top="300px"
      @confirm="UpdateIcuShowOk">
      <span style="color: rgb(245, 229, 7)">重启会影响设备的正常运行，是否继续重启？</span>
    </gs-modal>
    <gs-modal v-model="descChangjing" :before-close="descChangjingClose" class="gsmodal-box" top="70px" title="场景详情"
      width="80%" @confirm="descChangjingClose">
      <div style="width: 100%; height: 600px"></div>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";
import alarmService from "../../service/alarmService.js";
import moment from "moment";
import echarts from "echarts";
export default {
  components: {},
  data() {
    return {
      operationTime: "", //部署时间
      descChangjing: false,
      model: "",
      top: "请求协助",
      tUpdateIcuShow: false,
      tUpdateWebShow: false,
      communicationArray: [],
      showCommunication: false,
      percentShow: false,
      percentage: "0",
      appArray: [],
      bootArray: [],
      scenarioArrayData: [],
      scenarioConfigurationShow: false,
      updateTempBoot: false,
      updateTemp: false,
      deviceArrayData: [],
      devicePopup: false,
      treeNodeData: {},
      din: "暂无数据",
      tit: "场景信息",
      stopTime: moment(),
      defaultTime: moment(),
      activeName: "first",
      environment: false, //
      device: false,
      subDevice: false,
      isEdit: false,
      loading: false,
      activeName: "first",
      form: {
        createUser: "",
        addressOut: "",
        name: "",
        number: "",
        fileLink: "", // 链接
        address: "",
        describe: "",
        personCharge: "",
        inspect: "",
        supply: "",
        imgName: "",
        fileName: "",
        pice: "",
        depreciationPice: "",
        insurance: "",
        guarantee: "",
        stopTime: moment(),
        cycle: "",
        sn: "",
        version: "",
        din: "",
        ip: "",
        model: "",
        isLinked: "",
        mac: "",
        model1: "",
      },
      checked: "",
      tableData: [],
      description: "",
      fileLink: "", // 链接路径
      Din: "",
      name: "",
      disabled: true,
      deviceMassage: "1.02-2021/09/28-V1.0",
      sizeForm: {
        name: "",
        number: "",
        address: "",
        describe: "",
        personCharge: "",
        inspect: "",
        supply: "",
        imgName: "",
        fileName: "",
        pice: "",
        depreciationPice: "",
        insurance: "",
        guarantee: "",
        stopTime: moment(),
        timers: null,
      },
    };
  },
  computed: {
    ...mapState({
      visible: "deviceDialogShow",
      nodeData: "objectInfo", // 接到对象的所有属性
    }),
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData;
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus();
        }, 100);
        if (
          JSON.stringify(this.nodeData) !== "{}" &&
          this.nodeData.type === "device"
        ) {
          this.isEdit = true;
          this.din = this.nodeData.attribute.din;
          //this.form = this.nodeData.attribute
          this.description = this.nodeData.description;
          this.fileLink = this.nodeData.fileLink;
          this.name = this.nodeData.name;
          this.device = true;
          this.subDevice = false;
          this.environment = false;
          this.getNode();
        }
        if (
          JSON.stringify(this.nodeData) !== "{}" &&
          this.nodeData.type === "subDevice"
        ) {
          this.form = this.nodeData.attribute;
          this.description = this.nodeData.description;
          this.fileLink = this.nodeData.fileLink;
          this.name = this.nodeData.name;
          this.isEdit = true;
          this.device = false;
          this.subDevice = true;
          this.environment = false;
          this.top = "请求协助";
          this.getNode();
        }
        if (JSON.stringify(this.nodeData) === "{}") {
          this.form = {};
          this.description = "";
          this.name = "";
          this.isEdit = false;
          this.top = "请求协助";
        }
      }
    },
  },
  created() {
    if (localStorage.getItem("Authorization")) {
      this.getNode();
    }
  },
  mounted() {
    if (localStorage.getItem("Authorization")) {
      this.getNode();
    }
  },
  methods: {
    ...mapMutations({
      close: "DEVICE_DIALOG_HIDE",
      needReload: "NEED_RELOAD_TREE",
    }),
    descChangjingClose() {
      this.descChangjing = false;
    },
    updateTit() {
      this.top = "协助中...";
    },
    UpdateIcuShowClose() {
      this.tUpdateIcuShow = false;
    },
    UpdateIcuShowOk() {
      service
        .upgReset(this.nodeData.id)
        .then((res) => {
          this.$Message.success("重启成功！");
        })
        .catch((err) => {
          this.$Message.error(err);
        });
      this.tUpdateIcuShow = false;
    },
    UpdateWebShowClose() {
      this.tUpdateWebShow = false;
    },
    UpdateWebShowOk() {
      service
        .updateWeb(this.nodeData.id)
        .then((res) => {
          this.$Message.success("更新成功！");
        })
        .catch((err) => {
          this.$Message.error(err);
        });
      this.tUpdateWebShow = false;
    },
    CommunicationClose() {
      this.showCommunication = false;
    },

    communicationShowOk() {
      let sn = this.nodeData.attribute.sn;
      let sub = this.nodeData.name;
      alarmService
        .findSubDeviceOfflineLog(sn, sub)
        .then((res) => {
          this.communicationArray = res;
        })
        .catch((err) => { });
      this.showCommunication = true;
    },
    // 子设备通讯记录
    communicationOk() {
      this.showCommunication = false;
    },
    // 更新web
    updateNewWeb() {
      this.tUpdateWebShow = true;
    },
    // 重启ICU
    updateWeb() {
      this.tUpdateIcuShow = true;
    },
    updateTempOpen() {
      let _this = this;
      this.updateTemp = true;
      service.icuFile(this.form.sn, "app").then((res) => {
        let arrList = [];
        if (res) {
          arrList.push(res);
        }
        _this.appArray = arrList;
      });
    },
    updateTempBootOpen() {
      let _this = this;
      this.updateTempBoot = true;
      service.icuFile(this.form.sn, "boot").then((res) => {
        let arrList = [];
        if (res) {
          arrList.push(res);
        }
        _this.bootArray = arrList;
      });
    },
    beforeCloseUpdateTempBoot() {
      this.updateTempBoot = false;
      service
        .icuCancel(this.form.din)
        .then((res) => { })
        .catch((err) => {
          this.$Message.error(err);
        });
    },
    handleConfirmUpdateTempBoot() {
      let _this = this;
      let files = document.getElementById("uploadPicBoot").files;
      let file = files[0];
      let formDatas = new FormData();
      formDatas.append("uid", localStorage.getItem("userId"));
      formDatas.append("din", "333736303131511500470046");
      formDatas.append("file", files[0]);
      service.upgradeBoot(formDatas).then((res) => {
        console.log(res);
        _this.updateTempBoot = false;
      });
      _this.updateTempBoot = false;
    },
    beforeCloseUpdateTemp() {
      this.updateTemp = false;
      service
        .icuCancel(this.form.din)
        .then((res) => { })
        .catch((err) => {
          this.$Message.error(err);
        });
    },
    handleConfirmUpdateTemp() {
      let _this = this;
      let files = document.getElementById("uploadPic").files;
      let file = files[0];
      let formDatas = new FormData();
      formDatas.append("uid", localStorage.getItem("userId"));
      formDatas.append("din", "333736303131511500470046");
      formDatas.append("file", files[0]);
      service.upgradeIcu(formDatas).then((res) => {
        console.log(res);
        _this.updateTemp = false;
      });
      _this.updateTemp = false;
    },
    // 时间转化
    timeTran(row, column) {
      /* let data = row.timestamp
      return moment.unix(data).format('YYYY-MM-DD HH:mm:ss') */
      var date = new Date(row.timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1) + "-"
          : date.getMonth() + 1 + "-";
      let D =
        date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
      let h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      let m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    beforeCloseDevice() {
      this.devicePopup = false;
    },
    equipment() {
      this.tit = "设备信息";
      this.environment = true;
    },
    scene() {
      this.tit = "场景信息";
      this.environment = true;
    },
    beforeCloseEviro() {
      this.environment = false;
    },
    closeEviro() {
      this.environment = false;
    },
    beforeConfirmEviro() {
      this.environment = false;
    },
    handleConfirmEviro() {
      this.environment = false;
    },
    beforeClose() {
      clearInterval(this.timers);
      this.close();
      this.device = false;
      this.subDevice = false;
      this.environment = false;
    },
    beforeClose1() {
      clearInterval(this.timers);
      this.close();
      this.device = false;
      this.subDevice = false;
      this.environment = false;
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      // done(false)可以阻止modal关闭
      done();
    },
    handleConfirm() {
      this.loading = true;
      let param = {
        mqttId: this.nodeData.mqttId,
        keyPrefix: this.nodeData.keyPrefix,
        sort: this.nodeData.sort,
        fullId: this.nodeData.fullId,
        fullName: this.nodeData.fullName,
        secondName: this.nodeData.secondName,
        timeStamp: this.nodeData.timeStamp,
        unit: this.nodeData.unit,
        id: this.nodeData.id,
        fileLink: this.fileLink,
        // fileLink: this.form.fileLink,
        name: this.name,
        type: this.nodeData.type,
        value: this.nodeData.value,
        parentId: this.nodeData.parentId,
        memo: this.nodeData.memo,
        description: this.description,
        attribute: this.form, // 其他信息这里，键值对形式
      };
      /* let param = {
        id: this.nodeData.id,
        'desc': this.description,
        'name': this.name,
        "number":this.form.number
      } */
      let _this = this;
      service
        .renamePoint(param)
        .then((res) => {
          _this.nodeData.name = _this.name;
          _this.nodeData.attribute.address = _this.form.address;
          _this.nodeData.attribute.number = _this.form.number;
          _this.nodeData.description = _this.description;
          _this.nodeData.fileLink = _this.fileLink;
          // _this.nodeData.fileLink = _this.form.fileLink;
          _this.loading = false;
          _this.$notify.success({
            message: "修改成功",
            offset: 24,
            showClose: false,
            duration: "1000",
          });
          _this.beforeClose();
        })
        .catch((err) => {
          _this.loading = false;
          _this.$Message.error(err.message);
        });
      _this.loading = false;
    },
    handleConfirm1() {
      this.loading = true;
      let param = {
        mqttId: this.nodeData.mqttId,
        keyPrefix: this.nodeData.keyPrefix,
        sort: this.nodeData.sort,
        fullId: this.nodeData.fullId,
        fullName: this.nodeData.fullName,
        secondName: this.nodeData.secondName,
        timeStamp: this.nodeData.timeStamp,
        unit: this.nodeData.unit,
        id: this.nodeData.id,
        // fileLink: this.fileLink,
        fileLink: this.form.fileLink,
        name: this.name,
        type: this.nodeData.type,
        value: this.nodeData.value,
        parentId: this.nodeData.parentId,
        memo: this.nodeData.memo,
        description: this.description,
        attribute: this.form, // 其他信息这里，键值对形式
      };
      let _this = this;
      service
        .renamePoint(param)
        .then((res) => {
          _this.nodeData.name = _this.name;
          _this.nodeData.attribute.address = _this.form.address;
          _this.nodeData.attribute.number = _this.form.number;
          _this.nodeData.description = _this.description;
          _this.nodeData.fileLink = _this.form.fileLink;
          _this.loading = false;
          _this.$notify.success({
            message: "修改成功",
            offset: 24,
            showClose: false,
            duration: "1000",
          });
          _this.beforeClose1();
        })
        .catch((err) => {
          _this.loading = false;
          _this.$Message.error(err.message);
        });
      _this.loading = false;
    },
    onChange(v) { },
    // 获取节点数据
    getNode() {
      service
        .getNode(this.nodeData.id)
        .then((res) => {
          this.treeNodeData = res;
          this.form.sn = res.attribute.sn;
          this.form.version = res.attribute.version;
          this.form.din = res.attribute.din;
          this.form.ip = res.attribute.ip;
          this.form = res.attribute;
          this.operationTime = moment
            .unix(res.timeStamp)
            .format("YYYY-MM-DD HH:mm:ss");
          if (res.attribute.isLinked) {
            this.form.isLinked = "已连接";
          } else {
            this.form.isLinked = "未连接";
          }
          if (res.attribute.mac) {
            this.form.mac = res.attribute.mac;
          } else {
            this.form.mac = "暂无";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取设备、子设备上下线列表
    trendData() {
      //
      this.devicePopup = true;
      /* let data = {
        deviceId: this.nodeData.id
      }
      console.log(this.nodeData) */
      alarmService
        .findDeviceOfflineLog(this.nodeData.attribute.sn)
        .then((res) => {
          this.deviceArrayData = res;
        })
        .catch((err) => { });
      this.deviceLineShow = true;
    },
    // 获取场景配置列表
    tableDataIcu() {
      service
        .icuSceneConfig(this.form.sn)
        .then((res) => {
          this.scenarioConfigurationShow = true;
          let arr = [];
          if (res) {
            arr.push(res);
          }
          this.scenarioArrayData = arr;
        })
        .catch((err) => {
          this.scenarioConfigurationShow = true;
          this.scenarioArrayData = err;
        });
    },
    // 场景配置列表窗口关闭
    beforeCloseUpdateScenario() {
      this.scenarioConfigurationShow = false;
      this.percentShow = false;
    },
    handleConfirmScenario() {
      this.scenarioConfigurationShow = false;
    },
    updateScenario(val) {
      let _this = this;
      this.percentShow = true;
      let obj = {
        din: this.din,
        id: val.id,
      };
      service.setSceneConfig(this.din, val.id).then((res) => {
        _this.timers = setInterval(() => {
          _this.getpercentData();
        }, 1000);
      });
    },
    appOk(val) {
      let _this = this;
      service
        .programUpgradeICU(localStorage.getItem("userId"), this.din, val.id)
        .then((res) => {
          /* this.$Message.success("下载成功") */
        });
      this.percentShow = true;

      _this.timers = setInterval(() => {
        _this.getpercentData();
      }, 1000);
    },
    bootOk(val) {
      let _this = this;
      service
        .programUpgradeBoot(localStorage.getItem("userId"), this.din, val.id)
        .then((res) => {
          /* this.$Message.success("下载成功") */
        });
      this.percentShow = true;

      _this.timers = setInterval(() => {
        _this.getpercentData();
      }, 1000);
    },
    // 下载进度条
    getpercentData() {
      let _this = this;
      service
        .getProgressBar(this.din)
        .then((res) => {
          let a = res.progressBar.split("%");
          let b = a[0];
          if (b == 100) {
            _this.percentage = "100";
            clearInterval(_this.timers);
            this.$Message.success("下载成功");
            setTimeout(() => {
              _this.percentShow = false;
              // _this.percentage = '0'
            }, 2000);
          } else {
            _this.percentage = a[0];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeCloseCurve() {
    clearInterval(this.timers);
  },
};
</script>
<style scoped>
.gsmodal-box>>>.gs-modal-content {
  padding: 10px 10px 10px 10px !important;
}

.gsmodal-box>>>.gs-modal-footer {
  margin-top: 0px !important;
}

.gsmodal-box>>>.gs-modal-body {
  margin-top: 10px !important;
}

.gsmodal-box>>>.gs-modal-header {
  height: 28px !important;
  line-height: 23px !important;
}

.content-echarts {
  width: 100%;
  height: 500px;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 100%;
  float: left;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.desc>>>.gs-form-item-label {
  width: 23px;
}

.btn-device>>>.el-button {
  background-color: transparent;
  color: #d9d9d9 !important;
  border: 1px solid #777575 !important;
  width: 100%;
  float: right;
}

.btn-device>>>.el-button:hover {
  background-color: transparent;
  color: #ff7b00 !important;
  border: 1px solid #777575 !important;
  width: 100%;
  float: right;
}

.annon {
  width: 100%;
  height: 100%;
}

.echarts-main {
  width: 100%;
  height: 100px;
}

.timeSwitch-tit {
  color: rgb(245, 129, 6);
  font-size: 12px;
  cursor: pointer;
}

t {
  color: rgba(245, 229, 7, 0.587);
}
</style>


// WEBPACK FOOTER //
// src/components/deviceAbout/device.vue